import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreDefaultRedirectRoute: InvariantJiraRoute = {
	name: 'project-settings-core-redirect',
	path: '/jira/core/projects/:projectKey/settings',
};
